import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
/*import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
*/
import Router from 'vue-router';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { backend_url } from './config/url.config.ts'
import router from "./router";
import store from "./store";

import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import 'mapbox-gl/dist/mapbox-gl.css';

import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import JsonExcel from 'vue-json-excel';

import { VLazyImagePlugin } from "v-lazy-image";

library.add(fas, fab)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
//const socket = io(backend_url, { transports: ['polling'] });
//Vue.use(VueSocketIOExt, socket);

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'), {
    moment
});
/* Vue.use(require('vue-moment')); */

Vue.use(Router);

Vue.use(VLazyImagePlugin);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
